import React from 'react';
import SubscribeForm from 'components/Form/SubscribeForm';
import snackbar from 'utils/snackbar';
import Styles from 'components/Styles';
import { EmailSubscribeFormContainer } from './styles';

const EmailSubscribeForm = ({
  buttonType,
  dataPosition,
  label,
  inlineMarketingForm,
  onSuccess,
  styles,
}) => {
  return (
    <Styles {...styles}>
      <EmailSubscribeFormContainer>
        <SubscribeForm
          buttonType={buttonType}
          dataPosition={dataPosition}
          formClassNames="subscribe-form"
          formType="Email Capture"
          label={label}
          inlineMarketingForm={inlineMarketingForm}
          notificationSnack
          onSuccess={() => onSuccess || snackbar('Thanks for subscribing!', 'success')}
          shouldRedirect={false}
        />
      </EmailSubscribeFormContainer>
    </Styles>
  );
};

export default EmailSubscribeForm;

EmailSubscribeForm.defaultProps = {
  buttonType: 'primary',
  label: false,
};
